import React from 'react';

interface Props extends React.PropsWithChildren {
    onError: (error: Error, info: React.ErrorInfo) => void;
    fallbackElement?: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: !!error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.props.onError(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallbackElement ?? <></>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
